// extracted by mini-css-extract-plugin
export default {"routineInstructions":"routineInstructions-OeOkB","instructions":"instructions-FHvFO"};